<div>
  @for (routeSignpost of routeSignpostList.RouteSignpost; track trackByFn($index)) {
    <ul class="signposts-list" >
      <li class="direction-item" (mouseover)="onMouseOver(routeSignpost.StartRouteLeg)" (mouseout)="onMouseOut(routeSignpost.StartRouteLeg)" (click)="onClicked(routeSignpost.StartRouteLeg)" (keyup.enter)="onClicked(routeSignpost.StartRouteLeg)" tabindex="0">
        <div class="distance"> <strong>Start: </strong></div>
        <div class="instructions">{{routeSignpost.StartRouteLeg.Summary}}</div>
      </li>
      @for (routeLeg of routeSignpost.RouteLegs; let idx = $index; track trackByFn($index)) {
        <li >
          <div class="direction-item" (mouseover)="onMouseOver(routeLeg)" (mouseout)="onMouseOut(routeLeg)" (click)="onClicked(routeLeg)" (keyup.enter)="onClicked(routeLeg)" tabindex="0">
            <div class="distance">{{ routeLeg.Distance }}</div>
            <div class="instructions" >
              <div [innerHTML]="routeLeg.Summary"> </div>
              @if (routeLeg.Road.length) {
                <div class="route-signposts">
                  @switch (routeLeg.Type) {
                    @case (1) {
                      <aa-motorway-signpost [road]="routeLeg.Road" ></aa-motorway-signpost>
                    }
                    @case (2) {
                      <aa-primary-road-signpost [road]="routeLeg.Road"></aa-primary-road-signpost>
                    }
                    @case (3) {
                      <aa-local-road-signpost [road]="routeLeg.Road"></aa-local-road-signpost>
                    }
                    @case (5) {
                      <aa-signpost [road]="routeLeg.Road"></aa-signpost>
                    }
                    @case (6) {
                      <aa-raf-base-signpost [road]="routeLeg.Road"></aa-raf-base-signpost>
                    }
                    @case (7) {
                      <aa-hospital-signpost [road]="routeLeg.Road"></aa-hospital-signpost>
                    }
                    @case (4) {
                      <aa-place-of-interest-signpost [road]="routeLeg.Road"></aa-place-of-interest-signpost>
                    }
                  }
                </div>
              }
            </div>
          </div>
          @if (routeLeg.MemberBenefits) {
            <div class="direction-item" (mouseover)="onMouseOver(routeLeg)" (mouseout)="onMouseOut(routeLeg)" (click)="onClicked(routeLeg)" (keyup.enter)="onClicked(routeLeg)" tabindex="0">
              <div class="distance">{{ routeLeg.Distance }}</div>
              <div class="instructions" >
                <aa-route-member-benefit [data]="routeLeg.MemberBenefits"></aa-route-member-benefit>
              </div>
            </div>
          }
        </li>
      }
      <li class="direction-item" (mouseover)="onMouseOver(routeSignpost.EndRouteLeg)" (mouseout)="onMouseOut(routeSignpost.EndRouteLeg)" (click)="onClicked(routeSignpost.EndRouteLeg)" (keyup.enter)="onClicked(routeSignpost.EndRouteLeg)" tabindex="0">
        <div class="distance">{{routeSignpost.EndRouteLeg.Distance}}</div>
        <div class="instructions"><strong>Arrive: </strong>{{routeSignpost.EndRouteLeg.Summary}}</div>
      </li>
      <li class="direction-item section">
        <div class="distance"></div>
        <div class="instructions" [innerHTML]="routeSignpost.durationToPrint()"> </div>
      </li>
    </ul>
  }

</div>
